(() => {
  angular
    .module('gm.common.filters')
    .filter('gmTruncate', gmTruncateFilter);

  function gmTruncateFilter() {
    'ngInject';

    return (input, length) => {
      if (!input) {
        return input;
      }
      return input.length > length ? `${input.substring(0, length)}…` : input;
    };
  }
})();
